import React from 'react'
import { Navigate } from 'react-router'
import { useUserAuthStore } from '../stores/global/userAuth'

interface GuestRouteProps {
  children: React.ReactNode
  redirectTo?: string
}

const GuestRoute: React.FC<GuestRouteProps> = ({ children, redirectTo = "/dashboard" }) => {
  const { token } = useUserAuthStore()

  const isAuthenticated = (): boolean => {
    if (!token) return false
    else return true
  }

  if (isAuthenticated()) {
    return <Navigate to={redirectTo} replace />
  }

  return <>{children}</>
}

export default GuestRoute
